// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero-module--hero--1mu5e","title":"Hero-module--title--2hCsN"};